import { Capacitor } from '@capacitor/core';
import { SecureStorage } from '@aparajita/capacitor-secure-storage';

const native = Capacitor.isNativePlatform();
const cache = new Map();
let initialized = false;

const SESSION_KEYS = [
  'pulsora_access_token',
  'pulsora_refresh_token',
  'pulsora_center_id',
  'pulsora_active_role',
];

const webSession = () => {
  try { return window.sessionStorage; } catch (_) { return null; }
};

const nativeWrite = (operation) => {
  Promise.resolve(operation).catch(error => {
    // No exponemos credenciales en logs. Solo dejamos una señal técnica.
    console.error('Pulsora secure storage operation failed.', error?.name || 'StorageError');
  });
};

export const initializePlatformStorage = async () => {
  if (initialized) return;
  if (!native) {
    initialized = true;
    return;
  }

  await SecureStorage.setKeyPrefix('pulsora_native_');
  const values = await Promise.all(SESSION_KEYS.map(async key => {
    try {
      const value = await SecureStorage.getItem(key);
      return [key, value];
    } catch (_) {
      return [key, null];
    }
  }));
  values.forEach(([key, value]) => {
    if (value !== null && value !== undefined) cache.set(key, String(value));
  });
  initialized = true;
};

export const sessionStore = {
  isNative: native,
  getItem(key) {
    if (native) return cache.has(key) ? cache.get(key) : null;
    return webSession()?.getItem(key) || null;
  },
  setItem(key, value) {
    const normalized = String(value);
    if (native) {
      cache.set(key, normalized);
      nativeWrite(SecureStorage.setItem(key, normalized));
      return;
    }
    webSession()?.setItem(key, normalized);
  },
  removeItem(key) {
    if (native) {
      cache.delete(key);
      nativeWrite(SecureStorage.removeItem(key));
      return;
    }
    webSession()?.removeItem(key);
  },
};

export const clearNativeSessionStore = async () => {
  SESSION_KEYS.forEach(key => cache.delete(key));
  if (!native) return;
  await Promise.all(SESSION_KEYS.map(key => SecureStorage.removeItem(key).catch(() => undefined)));
};
